// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../types';

type Props = {
  videoSrc: string,
  title: string,
};

const Wrapper = styled<any, Theme>('div')`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 35px;
  height: 0;
  overflow: hidden;
`;

const Iframe = styled<any, Theme>('iframe')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
`;

const Video = ({
  videoSrc,
  title,
}: Props) => (
  <Wrapper>
    <Iframe
      title={title}
      src={videoSrc}
      frameBorder="0"
      allow="autoplay; encrypted-media"
      allowFullScreen
      height="315"
      width="560"
    />
  </Wrapper>
);

export default Video;
